import { LogoutOutlined } from '@ant-design/icons';
import { useLogout } from '@refinedev/core';
import { Button, Divider, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import { useUiContext } from '@/contexts/UiContext';
import { useUserContext } from '@/contexts/UserContext';
import { UserWorkAreaString } from '@/model/General/UserWorkArea';

import LanguageSegmented from './LanguageSegmented';
import ThemeSegmented from './ThemeSegmented';

const UserMenuContent = () => {
  const { t } = useTranslation();
  const { mutate: logout } = useLogout();
  const { isMobile } = useUiContext();
  const { devOptions } = useUserContext();
  // Reutilizamos el mismo release que reporta Sentry para mostrar la version cargada en la UI.
  const sentryRelease = import.meta.env.VITE_SENTRY_RELEASE?.trim();
  // Si el release es un SHA completo, mostramos una version corta como referencia visual similar a GitLab.
  const sentryReleaseDisplay =
    sentryRelease && /^[0-9a-f]{40}$/i.test(sentryRelease)
      ? sentryRelease.slice(0, 8)
      : sentryRelease;

  return (
    <Flex vertical gap={6}>
      {isMobile && devOptions && (
        <AntdSelect
          size="small"
          value={devOptions.selectedWorkArea}
          onChange={devOptions.handleChangeWorkArea}
          options={Object.keys(UserWorkAreaString).map(v => ({
            label: UserWorkAreaString[v as keyof typeof UserWorkAreaString],
            value: v,
          }))}
        />
      )}
      <Divider orientation="left" plain style={{ margin: '8px 0 2px' }}>
        {t('Lenguaje')}
      </Divider>
      <LanguageSegmented />

      <Divider orientation="left" plain style={{ margin: '8px 0 2px' }}>
        {t('Tema')}
      </Divider>
      <ThemeSegmented />

      <Divider style={{ margin: '8px 0 2px' }} />

      <Button type="text" onClick={() => logout()} icon={<LogoutOutlined />}>
        {t('Cerrar sesión')}
      </Button>

      <div className="LayoutHeaderReleaseTag" title={sentryRelease}>
        {t('Release')}: {sentryReleaseDisplay ? sentryReleaseDisplay : 'Local'}
      </div>
    </Flex>
  );
};

export default UserMenuContent;
